var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { height: "calc(100vh - 70px)", overflow: "hidden auto" },
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": "auto",
            "label-position": "right",
            size: "mini",
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card mb10" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.CustomerName") + "：",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.queryForm.customerAlias)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("basicData.UnsettledTotalAmount") + "：",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.queryForm.unsettledAmount)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.AccountBalance") + "：",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.queryForm.balance))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.TotalBalance") + "：",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.queryForm.totalBalance)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("basicData.category") + "：" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("basicData.PleaseSelect"),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.getDetailTable(1)
                                },
                              },
                              model: {
                                value: _vm.accountFlowForm.params.receiptType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.accountFlowForm.params,
                                    "receiptType",
                                    $$v
                                  )
                                },
                                expression:
                                  "accountFlowForm.params.receiptType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: 0,
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                key: 1,
                                attrs: {
                                  label: _vm.$t("basicData.acceptanceCheck"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: {
                                  label: _vm.$t("basicData.recharge"),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.TradingHours") + "：",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": _vm.$t("operationCenter.to"),
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            on: {
                              change: function ($event) {
                                return _vm.getDetailTableData()
                              },
                            },
                            model: {
                              value: _vm.queryDate,
                              callback: function ($$v) {
                                _vm.queryDate = $$v
                              },
                              expression: "queryDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-bottom": "18px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "but:finance:basicData:accountManagement:ExportAccountRollover",
                      expression:
                        "'but:finance:basicData:accountManagement:ExportAccountRollover'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.exportAccount()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("basicData.ExportAccountRollover")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "but:finance:basicData:accountManagement:recharge",
                      expression:
                        "'but:finance:basicData:accountManagement:recharge'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.rechargeAccount()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.recharge")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              ref: "elTable",
              attrs: {
                data: _vm.tableData,
                border: "",
                size: "small",
                "row-key": "id",
                "tree-props": { children: "siteReceipts" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "tradeTime",
                  label: _vm.$t("basicData.TradingHours"),
                  align: "left",
                  width: "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiptNumber",
                  label: _vm.$t("basicData.BatchNo"),
                  width: "240",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.receiptType !== 1
                          ? _c(
                              "span",
                              {
                                staticClass: "batchNumber",
                                on: {
                                  click: function ($event) {
                                    return _vm.showBillBatchNumber(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.receiptNumber))]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.receiptNumber)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "actualFeeBrl",
                  label: _vm.$t("basicData.PaymentAmount") + "(BRL)",
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.actualFeeBrl))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "billFee",
                  label: _vm.$t("basicData.TicketAmount") + "(BRL)",
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "actualFee",
                  label: _vm.$t("basicData.amountPaymentOriginal"),
                  align: "center",
                  width: "120",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "currencyName",
                  label: _vm.$t("basicData.Currency"),
                  align: "center",
                  width: "120",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.currencyName) +
                              "(" +
                              _vm._s(scope.row.currencyCode) +
                              ")"
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "exchangeRate",
                  label: _vm.$t("basicData.exchangeRate"),
                  align: "center",
                  width: "120",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiptType",
                  label: _vm.$t("basicData.category"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              scope.row.receiptType === 0
                                ? _vm.$t("basicData.acceptanceCheck")
                                : _vm.$t("basicData.recharge")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiptStatus",
                  label: _vm.$t("basicData.status"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              scope.row.receiptStatus === 0
                                ? _vm.$t("receivablePayable.ToBeVerified")
                                : _vm.$t("basicData.Received")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ticketNumber",
                  label: _vm.$t("basicData.TicketNumber"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.ticketNumber))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "accountAlias",
                  label: _vm.$t("basicData.GoAccount"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.accountAlias))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiptMethod",
                  label: _vm.$t("basicData.PaymentMethod"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.receiptMethod === "cash"
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.$t("basicData.cash"))),
                            ])
                          : _vm._e(),
                        scope.row.receiptMethod === "transfer"
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.$t("basicData.transferable"))),
                            ])
                          : _vm._e(),
                        scope.row.receiptMethod === "network"
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.$t("basicData.online"))),
                            ])
                          : _vm._e(),
                        scope.row.receiptMethod === "sterilisation"
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.$t("basicData.Elimination"))),
                            ])
                          : _vm._e(),
                        scope.row.receiptMethod === "other"
                          ? _c("div", [
                              _vm._v(_vm._s(_vm.$t("basicData.other"))),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "beforeBalance",
                  label: _vm.$t("basicData.BalanceBeforeOperation"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "afterBalance",
                  label: _vm.$t("basicData.BalanceAfterOperation"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "attachmentUrl",
                  label: _vm.$t("basicData.annex"),
                  align: "center",
                  width: "200",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.attachmentUrl &&
                        scope.row.attachmentUrl.length
                          ? _c(
                              "el-link",
                              {
                                staticStyle: { "font-size": "12px" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getImgSrc(
                                      scope.row.attachmentUrl
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("basicData.View")))]
                            )
                          : _vm._e(),
                        _c(
                          "el-link",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "padding-left": "10px",
                            },
                            attrs: { icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                return _vm.openUpdateFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.Edit")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("receivablePayable.remark"),
                  align: "left",
                  "min-width": "200",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", {
                          staticClass: "remarkStyle",
                          domProps: { innerHTML: _vm._s(scope.row.remark) },
                          on: {
                            click: function ($event) {
                              return _vm.showImg($event)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createUserName",
                  label: _vm.$t("basicData.CreatePeople"),
                  align: "center",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.accountFlowForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.accountFlowForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.accountFlowForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.accountFlowForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.accountFlowForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.accountFlowForm, "pageSize", $event)
                  },
                  "current-change": _vm.getDetailTable,
                  "size-change": _vm.getDetailTable,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("basicData.AccountDetails"),
            "append-to-body": true,
            visible: _vm.showDetailList,
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailList = $event
            },
          },
        },
        [
          _c("batch-number-detail", {
            key: _vm.detailKeyList,
            attrs: { "detail-query": _vm.detailQuery },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("basicData.recharge"),
            visible: _vm.showCollection,
            "append-to-body": true,
            top: "10vh",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCollection = $event
            },
          },
        },
        [
          _c("collection-detail", {
            key: _vm.collectionKey,
            attrs: {
              "recharge-data": _vm.queryForm,
              "account-option": _vm.accountOption,
            },
            on: { collectionUpdate: _vm.collectionUpdate },
          }),
        ],
        1
      ),
      _c("UpdateFileCmp", {
        ref: "updateFileRef",
        on: { update: _vm.getDetailTable },
      }),
      _vm.imageViewerObj.showViewer
        ? _c("FilePreview", {
            attrs: { "file-list": _vm.imageViewerObj.imgArr },
            on: { close: _vm.closeViewer },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }